import { api } from '../api';
export const historyApi = api.injectEndpoints({
    endpoints: (build) => ({
        getHistory: build.query({
            query: (args) => ({
                url: `tier-management-service/api/v1/widget/user/history`,
                headers: {
                    'X-Loyalty-Language': (args.locale).split('-')[0],
                    'Authorization': `Bearer ${args.jwt}`
                }
            }),
            forceRefetch: () => true
        })
    })
});
//# sourceMappingURL=history.api.js.map